import React from 'react';
import ReactDOM from 'react-dom';
import { Amplify } from 'aws-amplify';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { API, COGNITO } from './config';

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: COGNITO.REGION,
    userPoolId: COGNITO.USER_POOL_ID,
    identityPoolId: COGNITO.IDENTITY_POOL_ID,
    userPoolWebClientId: COGNITO.APP_CLIENT_ID
  },
  API: {
    endpoints: [
      {
        name: 'sms-api',
        endpoint: API.URL,
        region: API.REGION
      }
    ]
  }
});

ReactDOM.render(<App />, document.querySelector('#root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
